import React from "react";
import ProductList from "../components/ProductList";

const subCategoryList = [
  { id: 1, name: "Accessories" }
];

const productList = [
    { id: 1, name: "OTDR"     	               , image: "/images/mini-otdr-4000.jpg", description: "Tools.", category: "OTDR", subCategoryId: 0 },
    { id: 2, name: "Power Source & Meter"	   , image: "/images/fms-10-mpo-power-meter-and-laser-source.jpg", description: "Tools.", category: "Power Source & Meter", subCategoryId: 0 },
    { id: 3, name: "CCTV System"	           , image: "/images/cctv-installation-services.jpg", description: "Tools.", category: "CCTV System", subCategoryId: 0 },
    { id: 4, name: "EPBAX System"	           , image: "/images/epabx-intercom-system-service.jpeg", description: "Tools.", category: "EPABX System", subCategoryId: 0 },
    { id: 5, name: "Optical Fiber Cable"	   , image: "/images/fiber-optic-cable.jpg", description: "Tools.", category: "Optical Fiber Cable", subCategoryId: 0 },
    { id: 6, name: "Patch Cord"               , image: "/images/lc-to-lc-single-mode-duplex-patch-cord.jfif", description: "Tools.", category: "Accessories", subCategoryId: 0 },
    { id: 7, name: "Fibre Termination Closure", image: "/images/optical-fibre-cable-joint-closure.jpeg", description: "Tools.", category: "Accessories", subCategoryId: 0 },
    { id: 8, name: "SFP"                      , image: "/images/sfp.jpg", description: "Tools.", category: "Accessories", subCategoryId: 0 },];

const Telicom: React.FC = () => {
  return <ProductList title="Telicom Products" products={productList} subCategories={subCategoryList} categoryName="Telecom System"  />;
};

export default Telicom;
